import httpClient from './httpClient'

export default {
  getListItems(name) {
    return httpClient.get(`listitems/${name}`).then(r => r.data)
  }
}
